<template>
    <div>
        <b-dropdown-form style="width: 20rem;">
            <b-select :options="options" v-model="method" size="sm" class="mt-3">
                <template #first>
                    <b-form-select-option :value="null" disabled>Method</b-form-select-option>
                </template>
            </b-select>

            <b-input-group prepend="$" size="sm" class="mt-3">
                <b-input type="number" v-model="amount" placeholder="Amount" ></b-input>
            </b-input-group>

            <b-input-group prepend="Transaction" size="sm" class="mt-3" v-if="needsTransaction">
                <b-input v-model="transactionId"></b-input>
            </b-input-group>

            <!--<stripe-element-card v-if="method === 'Credit Card'"></stripe-element-card>-->

            <b-input-group prepend="Note" size="sm" class="mt-3">
               
                <b-input v-model="note"></b-input>
            </b-input-group>

            <div class="text-right mt-3">
                <b-button v-if='hasInitialValues' @click="deletePayment()" size="sm" variant="warning" class="mr-2">Delete</b-button>
                <b-button :disabled="!hasValues" @click="doPayment()" size="sm" variant="primary">{{hasInitialValues ? 'Update' : 'Add Payment'}}</b-button>
            </div>
        </b-dropdown-form>
    </div>
</template>

<script>
    import moment from "moment";
    // import { StripeElementCard } from '@vue-stripe/vue-stripe';

    export default {
        name: "Payment",
        props: [ 'initialMethod', 'initialTransactionId', 'initialAmount', 'initialNote' ],
        // components: { StripeElementCard },
        data() {
            return {
                method: this.initialMethod || null,
                transactionId: this.initialTransactionId || null,
                amount: this.initialAmount || null,
                note: this.initialNote || null,
                options: [
                    'Check',
                    'Cash',
                    'Money Order',
                    'PayPal',
                    'Credit Card',
                ]
            }
        },
        methods: {
            doPayment() {
                const paymentObj = {
                    username: this.$auth.user.nickname,
                    amount: this.amount,
                    method: this.method,
                    note: this.note,
                    transactionId: this.transactionId,
                    date: moment().format(),
                };

                this.$emit('addPayment', paymentObj);

                if (!this.hasInitialValues) {
                    this.amount = null;
                    this.method = null;
                    this.note = null;
                    this.transactionId = null;
                }
            },
            deletePayment() {
                this.$emit('removePayment')
            }
        },
        computed: {
            needsTransaction() {
                return this.method && (this.method === 'PayPal' || this.method === 'Credit Card');
            },
            hasValues() {
                return this.method && this.amount ? true : false;
            },
            hasInitialValues() {
                return this.initialMethod && this.initialAmount ? true : false;
                
            }
        },
        watch: {
            method(value) {
                if (value === 'Credit Card') {
                    console.log('changed!');
                }
            }
        }
    }
</script>

<style scoped>

</style>